import { render, staticRenderFns } from "./Rewardpoints.vue?vue&type=template&id=71287f0d"
import script from "./Rewardpoints.vue?vue&type=script&lang=js"
export * from "./Rewardpoints.vue?vue&type=script&lang=js"
import style0 from "./Rewardpoints.vue?vue&type=style&index=0&id=71287f0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports